export const referralRewardsRoutes = {
  referralRewards: () => '/referral-rewards',
  approveReferralReward: (inviteeId: string) => `/referral-rewards/${inviteeId}/approve`,
  rejectReferralReward: (inviteeId: string) => `/referral-rewards/${inviteeId}/reject`,
};
